const initialState = {
  request: false,
  data: [],
  error: false,
}
// eslint-disable-next-line
export default (state = initialState, action) => {
  switch (action.type) {
    case 'GET_CATEGORIES_REQUEST':
      return {
        ...state,
        request: true,
        error: false,
      }
    case 'GET_CATEGORIES_RESPONSE':
      return {
        ...state,
        request: false,
        data: action.payload.data,
        error: false,
      }
    case 'GET_CATEGORIES_ERROR':
      return {
        ...state,
        request: true,
        error: action.payload,
      }
    default:
      return state
  }
};
export const categoryRequest = state => state.request
export const categoryData = state => state.data
export const categoryError = state => state.error
